var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHotspotHeat = function SvgHotspotHeat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M10.883 6.83c-.163.28-.525.144-.56 0S9.211 2.809 8.155 1.992C7.098 2.81 6.02 6.686 5.986 6.83s-.397.28-.56 0c-.202-.35-.029-.944-.24-1.14-.235-.216-1.94 1.219-2.223 3.689s1.198 4.613 5.191 4.613c3.994 0 5.474-2.143 5.192-4.613s-1.988-3.905-2.222-3.689c-.212.196-.038.79-.241 1.14Z"
  })));
};
export default SvgHotspotHeat;